import { Button } from "@mui/material";

import "./style.scss";
import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";
import { AuthTemplate } from "../../../components/auth-template/auth-template.comp";

const EmailConfirm = () => {
    const { email, sendVerificationWaitingTime, logout, sendVerification } =
        FirebaseAuthContainer.useContainer();

    const handleClose = () => {
        logout();
    };

    const handleSendAgainClick = () => {
        sendVerification();
    };

    return (
        <AuthTemplate>
            <div className="email-confirm">
                <div className="email-confirm-title">Confirm Email</div>
                <div className="email-confirm-login">
                    <span className="email-confirm-login__text">
                        If you&apos;ve remembered your password, you can
                    </span>
                    <a onClick={handleClose} className="email-confirm-login__link">
                        Log In
                    </a>
                </div>
                <div className="email-confirm-description">
                    <span className="email-confirm-description__text">
                        <span>Confirmation link was sent to </span>
                        <span className="email-confirm-description__text-email">{email}</span>.
                        <br></br>
                        Click on the link in the email to complete the sign up proccess.
                    </span>
                </div>
                <div className="email-confirm-send-again">
                    <span className="email-confirm-send-again__text">
                        Didn&apos;t recieve it? Check spam or send again<br></br>
                        {sendVerificationWaitingTime ? `(in ${sendVerificationWaitingTime}s)` : ""}
                    </span>
                </div>
                <div className="email-confirm-action">
                    <Button
                        className="primary-button"
                        variant="text"
                        onClick={handleSendAgainClick}
                        disabled={!!sendVerificationWaitingTime}
                    >
                        Send Again
                    </Button>
                </div>
            </div>
        </AuthTemplate>
    );
};

export default EmailConfirm;
